import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Injectable } from "@angular/core";
import * as travelRequestAction from "./travel-request.action";
import { switchMap, map, catchError } from "rxjs/operators";
import { TravelService } from "../services/travel.service";
import { of } from "rxjs";

@Injectable()
export class TravelRequestEffects {
  constructor(private actions: Actions, private travelService: TravelService) {}

  $getTravelRequests = createEffect(() => {
    return this.actions.pipe(
      ofType(travelRequestAction.GetTravelRequestApiAction),
      switchMap((action) =>
        this.travelService.getTravelRequest(action.data).pipe(
          map((data) =>
            travelRequestAction.SuccessGetTravelRequestApiAction({ data })
          ),
          catchError(() => {
            return of(
              travelRequestAction.SuccessGetTravelRequestApiAction({
                data: {
                  addPayload: {
                    status: 0,
                    pageParams: {
                      pageNumber: 0,
                      pageSize: 0,
                      totalRecords: 0,
                    },
                  },
                },
              })
            );
          })
        )
      )
    );
  });

  $getTravelRequestApprovals = createEffect(() => {
    return this.actions.pipe(
      ofType(travelRequestAction.GetTravelRequestApprovalsApiAction),
      switchMap((action) =>
        this.travelService.getTravelRequestApprovals(action.data).pipe(
          map((data) =>
            travelRequestAction.SuccessGetTravelRequestApprovalsApiAction({
              data,
            })
          ),
          catchError(() => {
            return of(
              travelRequestAction.SuccessGetTravelRequestApprovalsApiAction({
                data: {
                  addPayload: {
                    status: 0,
                    pageParams: {
                      pageNumber: 0,
                      pageSize: 0,
                      totalRecords: 0,
                    },
                  },
                },
              })
            );
          })
        )
      )
    );
  });

  $getTravelRequestApprovalsSettings = createEffect(() => {
    return this.actions.pipe(
      ofType(travelRequestAction.GetTravelRequestApproverSettingsApiAction),
      switchMap((action) =>
        this.travelService.getTravelRequestApproverSettings().pipe(
          map((data) =>
            travelRequestAction.SuccessGetTravelRequestApproverSettingsApiAction(
              { data }
            )
          ),
          catchError(() => {
            return of(
              travelRequestAction.SuccessGetTravelRequestApproverSettingsApiAction(
                { data: {} }
              )
            );
          })
        )
      )
    );
  });
}
